const WORDS = {
  item: 'items',
  is: 'are',
  it: 'them',
  requires: 'require'
};

type Word = keyof typeof WORDS;

export const pluralize = (word: Word, count: number) => (count > 1 ? WORDS[word] : word);
